module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAeElEQVRIS2NkwAHUNn/+j0uOFHHGAbfgli8vTkfg8wksBAj6YNSC0SDCmZBGUxHB0gIeRKSWOcRmPPpbgO4ymAtg4uh8QmGE4YMBs4CQSwnJM+LyOqmRj8sinBagayA1DmD6Ry0gFMcM8CAiqBKqgNicjBEHtLIAANleql8RXHtcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/ju-right.png
// module id = wnwc
// module chunks = 0